// extracted by mini-css-extract-plugin
export default {"p_tye":"c6f82716b5","slcted":"_06a71215eb","slc_color":"_416100b8f6","item_p":"_852db21de4","r0":"cb74f44c87"};